import React, { useState } from 'react'
import PropTypes from 'prop-types'

import RoadmapV2 from 'model/carePlans/carePlan'
import useEntities from 'pages/CarePlanBuilder/hooks/useEntities'
import CostEstimationModal from 'components/CostEstimationModal'
import Facilities from 'pages/Facilities'
import Providers from 'pages/Providers'

import SelectedEntities from './SelectedEntities'

const CareStep = ({
  carePlan,
  setLoading,
  careStepFilters,
  resetCareStepFilters,
  requestType
}) => {
  const { isFacility, member } = carePlan

  const { id: memberId } = member

  const [visible, setVisible] = useState(false)
  const [selectedEntity, setSelectedEntity] = useState({})

  const onSelectEntity = entity => {
    setSelectedEntity(entity)
    setVisible(true)
  }

  const {
    entities,
    entitiesIDs,
    loading,
    carePlanLoading,
    onRemoveEntity,
    onSaveEntity
  } = useEntities(carePlan, setVisible, selectedEntity, setLoading, memberId)

  const onCancel = () => setVisible(false)

  return (
    <>
      <SelectedEntities
        isFacility={isFacility}
        selectedEntities={entities}
        onRemove={onRemoveEntity}
        onClick={onSelectEntity}
        loading={carePlanLoading}
      />
      {isFacility ? (
        <Facilities
          onSelectEntity={onSelectEntity}
          onRemoveEntity={onRemoveEntity}
          entitiesIDs={entitiesIDs}
          memberId={memberId}
          addButtonText="Add To Care Plan"
          careStepFilters={careStepFilters}
          resetCareStepFilters={resetCareStepFilters}
          isSelectionMode
        />
      ) : (
        <Providers
          onSelectEntity={onSelectEntity}
          onRemoveEntity={onRemoveEntity}
          entitiesIDs={entitiesIDs}
          memberId={memberId}
          careStepFilters={careStepFilters}
          resetCareStepFilters={resetCareStepFilters}
          requestType={requestType}
          isCarePlan
        />
      )}
      {visible && (
        <CostEstimationModal
          entity={selectedEntity}
          member_id={memberId}
          isFacility={isFacility}
          visible
          loading={loading}
          onCancel={onCancel}
          onSave={onSaveEntity}
        />
      )}
    </>
  )
}

CareStep.propTypes = {
  carePlan: PropTypes.shape(RoadmapV2.shape).isRequired,
  setLoading: PropTypes.func.isRequired,
  careStepFilters: PropTypes.shape({}).isRequired,
  resetCareStepFilters: PropTypes.func.isRequired,
  requestType: PropTypes.string.isRequired
}

export default CareStep
